import {
    ReviewConcordanceRequestFieldEnum,
    ReviewConcordanceRequestType,
} from '../../../../../../service/reivew-analysis/review-concordance/review-concordance-type';

export type KeywordsAndTopicsFormType = ReviewConcordanceRequestType & {
    [ReviewConcordanceRequestFieldEnum.Range]: [Date | null, Date | null];
};

export enum KeywordsAndTopicsFormTypeAggregationEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
}
